import { queryOptions } from "@tanstack/react-query";
import { fetchProfile } from "@features/myinfo/api/profile";
import { fetchHasPastReservation, fetchReservations } from "@features/myinfo/api/reservations";

/**
 * myinfo 도메인 쿼리 팩토리.
 * useQuery(myinfoQueries.profile()), invalidateQueries({ queryKey: myinfoQueries.profileKey() }) 등으로 사용.
 */
export const myinfoQueries = {
  all: () => ["myinfo"] as const,
  profileKey: () => [...myinfoQueries.all(), "profile"] as const,
  reservationsKey: (year: number, month: number) => [...myinfoQueries.all(), "reservations", year, month] as const,
  hasPastReservationKey: () => [...myinfoQueries.all(), "hasPastReservation"] as const,

  profile: () =>
    queryOptions({
      queryKey: myinfoQueries.profileKey(),
      queryFn: fetchProfile,
    }),

  reservations: (year: number, month: number) =>
    queryOptions({
      queryKey: myinfoQueries.reservationsKey(year, month),
      queryFn: () => fetchReservations(year, month),
      staleTime: 0,
      refetchOnWindowFocus: true,
      refetchOnReconnect: true,
    }),

  hasPastReservation: () =>
    queryOptions({
      queryKey: myinfoQueries.hasPastReservationKey(),
      queryFn: fetchHasPastReservation,
      staleTime: 0,
      refetchOnWindowFocus: true,
      refetchOnReconnect: true,
    }),
};
